import { CARD_NUMBER_LENGTH } from '@/constants';

export enum TravelCardStatus {
    Active = 'Active',
    Blocked = 'Blocked'
}

export const CARD_DIALOG = {
    NONE: -1,
    DELETE_CARD: (id: string | number) => `${id}-remove`,
    BLOCK_CARD: (id: string | number) => `${id}-block`
};

export const FIELD_RULES = {
    CARD_NAME_MAX_CHAR: 25,
    CARD_NAME_MIN_CHAR: 2,
    CARD_NUMBER_LENGTH_MIN: CARD_NUMBER_LENGTH.NEW,
    CARD_NUMBER_LENGTH_MAX: CARD_NUMBER_LENGTH.OLD
};

export const TRAVEL_CARD_BLOCK_ACTIONS_VALUES = {
    BLOCK_ONLY: 'block',
    BLOCK_AND_ORDER: 'block_and_order'
};
